module.exports = __webpack_public_path__ + "static/img/2.3250f4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/eng/2.png
// module id = jm5a
// module chunks = 0